/**
 * 行情相关路由配置
 */
const marketRoutes = [
  {
    path: '/market/today',
    name: 'TodayMarket',
    component: () => import('@/views/market/TodayMarketView.vue'),
    meta: {
      title: '今日行情',
      requireAuth: false,
      hideNav: true
    }
  }
]

export default marketRoutes
